import React from "react";

const DashboardPage: React.FC = () => <div>DashboardPage</div>;

export default React.memo(DashboardPage);
